export default class LaonhfcModel {
  constructor() {
    this.signImage1 = null; // 申請人
    this.signImage1Url = null;
    this.signImage2 = null; // 申請人
    this.signImage2Url = null;
    this.signImage3 = null; // 申請人
    this.signImage3Url = null;
    this.vendor = '';
    this.name = '';
    this.manufactureDate = '';
    this.publicYear = '';
    this.publicMonth = '';
    this.carId = '';
    this.cc = '';
    this.engineId = '';
    this.zeroRate = false; // 零利率
    this.otherProject = false; // 零利率
    this.projectName = ''; // 專案
    this.project0 = false; // 本牌新車
    this.project1 = false; // 他牌新車
    this.project2 = false; // 中古車
    this.project3 = false; // 原融
    this.project4 = false; // 借新還舊
    this.project5 = false; // 他行代償
    this.project6 = false; // 機車
  }
}



// WEBPACK FOOTER //
// ./src/models/LaonhfcModel.js